import { useCallback } from 'react';
import { parse } from 'query-string';
import api from '../api';

export const useExportListings = () => {
  const exportListings = useCallback(async ({ listingsToExport, pagination }) => {
    try {
      const totalItems = pagination?.totalItems || 0;
      const perPage = pagination?.perPage || 48;
      const totalPages = Math.ceil(totalItems / perPage);

      let allListings = [];

      if (totalPages > 1) {
        const searchParams = parse(window.location.search);

        for (let page = 1; page <= totalPages; page++) {
          const response = await api.listings.getSearchListings({
            ...searchParams,
            page,
            perPage,
          });

          const listingsFromPage = response.data?.data || [];
          allListings.push(...listingsFromPage);
        }
      } else {
        allListings = listingsToExport || [];
      }

      const listingIds = allListings.map(l => l.id.uuid || l.id);
      const response = await api.listings.exportListings({ listingIds });

      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'listings_export.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Export failed:', error);
      throw error;
    }
  }, []);

  return { exportListings };
};
